import { Fragment, useState, useRef } from 'react';

import { IconButton, Menu, MenuItem, MenuList, Popper, Paper, Grow, ClickAwayListener } from '@material-ui/core';
import MoreVertIcon from '@material-ui/icons/MoreVert';
import { logout } from '../../api/onboarding';
import UserCircle from '../../assets/UserCircle';
import { getFromLocalStorage, removeAllFromLocalStorage } from '../../utils/Helpers';
import { Link, useHistory, useLocation } from 'react-router-dom';

const UserIcon = () => {
	const [anchorEl, setAnchorEl] = useState(null);
  const token = getFromLocalStorage("token");
  const userData = getFromLocalStorage("userData");
  const [userStatue, setUserStatus] = useState(false);

  const history = useHistory();
  const location = useLocation();

  const [open, setOpen] = useState(false);

  const anchorRef = useRef(null);

  const handleClick = (event) => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };

  const hitLogout = () => {
  	removeAllFromLocalStorage();
  	setUserStatus(!useState);
  	logout();
  	history.push({pathname: '/', replace: true, search: location.search });
  }

  function handleListKeyDown(event) {
    if (event.key === 'Tab') {
      event.preventDefault();
      setOpen(false);
    }
  }

  const renderOptionalMenu = () => {
  	if (window.location.pathname === '/' || window.location.pathname === '/home') {
  		if (token?.step === 'register') {
	  		return <Link className="menuSubLink" to="/register"><MenuItem>Continue Applying</MenuItem></Link>
	  	} else if (token?.step === 'dashboard') {
	  		return <Link className="menuSubLink" to="/dashboard"><MenuItem>View dashboard</MenuItem></Link>
	  	} else if (token?.step === 'verification') {
			return <Link className="menuSubLink" to="/verification"><MenuItem>Continue Applying</MenuItem></Link>
		}
  	}
  }

  const renderName = () => {
  	if (userData?.firstName) {
  		return <Fragment>
  			{`${userData?.firstName} ${userData?.lastName}`}
  		</Fragment>
  	}
  }

  if (token?.step) {
  	return (
			<Fragment>
				<IconButton
	        aria-haspopup="true"
	        onClick={handleClick}
	        className="headerMenu"
	        ref={anchorRef}
	        aria-controls={open ? 'menu-list-grow' : undefined}
	      >
	        <UserCircle />
			<span>{renderName()}</span>	        
	      </IconButton>

	      <Popper 
	      	open={open} 
	      	anchorEl={anchorRef.current} 
	      	role={undefined} 
	      	transition 
	      	disablePortal
	      	anchorOrigin={{
				    vertical: 'top',
				    horizontal: 'left',
				  }}
				  transformOrigin={{
				    vertical: 'top',
				    horizontal: 'left',
				  }}
	      >
          {({ TransitionProps, placement }) => (
            <Grow
              {...TransitionProps}
              style={{ transformOrigin: placement === 'bottom' ? 'center top' : 'center bottom' }}
            >
              <Paper>
                <ClickAwayListener onClickAway={handleClose}>
                  <MenuList autoFocusItem={open} id="menu-list-grow" onKeyDown={handleListKeyDown}>
                    {renderOptionalMenu()}
                    <MenuItem onClick={() => hitLogout()}>Logout</MenuItem>
                  </MenuList>
                </ClickAwayListener>
              </Paper>
            </Grow>
          )}
        </Popper>
			</Fragment>
		)
  } else {
  	return <Fragment></Fragment>
  }

	
}

export default UserIcon;